export enum ProfileAccessLevel {
    User = 0,
    Account = 1,
    Global = 2,
}

export type ProfileDto = {
    id: string;
    name: string;
    isShared: boolean;
    accessLevel: ProfileAccessLevel;
    seniority: readonly string[];
    departments: readonly string[];
    includeTitles: readonly string[];
    excludeTitles: readonly string[];

    createdTime?: string;
    updatedTime?: string | null;
    creatorName?: string;
};

export type ContactProfileDtoList = readonly ProfileDto[];

export type ProfilesResponseDto = {
    profiles: ContactProfileDtoList;
    totalCount: number;
};

export type CreateProfileRequestDto = Omit<ProfileDto, "id" | "accessLevel" | "isShared"> & { isShared?: boolean };
export type CreateProfileResponseDto = ProfileDto;

export type UpdateProfileRequestDto = Omit<ProfileDto, "accessLevel">;
export type UpdateProfileResponseDto = ProfileDto;
